import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/campus-attendance-teachers', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = data => {
  return httpClient
    .post('/api/campus-attendance-teachers/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/campus-attendance-teachers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const header = (Options = {}) => {
  return httpClient
    .get('/api/campus-attendance-teachers/get-header', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const latestCheckIn = studentId => {
  return httpClient
    .get(`/api/campus-attendance-teachers/${studentId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  exportExcel,
  store,
  header,
  latestCheckIn 
}
